// extracted by mini-css-extract-plugin
export default {"filesList":"ActiveDropzone_filesList__e-BUL","singleImage":"ActiveDropzone_singleImage__FrkXY"};